import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import KnowUsBetterImageCards from 'src/app/organisms/Homepage/KnowUsBetterImageCards/KnowUsBetterImageCards';

const GetToKnowUsBetter = (): JSX.Element => {
  return (
    <SectionLayout
      maxWidth='width-3xl'
      padding={['spacing-7xl', 'spacing-4xl']}
      paddingSm={['spacing-4xl', 'spacing-xl']}
    >
      <KnowUsBetterImageCards />
    </SectionLayout>
  );
};

export default GetToKnowUsBetter;
